import Api from "@root/components/api";

export default class CardMutation {
    async load(id) {
        let query = `query($id: String!) {
            card(id: $id) {    
                id name my
                fields {
                    name value
                }
                skill {
                    id name
                    primarySubject { id name }
                }
                template {
                    id name
                    fieldSets {
                        id name 
                        fields {
                            name  type i18n  multi cardTemplateId cardFieldName user
                        }
                    }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: { id: id } });
        if (result.errors) {
            return;
        }

        return result.data.card;        
    }

    async loadCardFieldValues(cardId, cardTemplateId, cardFieldName) {
        let query = `query($cardId: String!, $cardTemplateId: String!, $cardFieldName: String!) {
            loadCardFieldValues(cardId: $cardId, cardTemplateId: $cardTemplateId, cardFieldName: $cardFieldName) {
                cardId skillName field {name value} def {type}
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: { 
            cardId: cardId,
            cardTemplateId: cardTemplateId,
            cardFieldName: cardFieldName,
        } });
        if (result.errors) {
            return;
        }

        return result.data.loadCardFieldValues;
    }
    
    async save(card, fields) {
        let query = `mutation ($input: CardInput!) {
            editCard(input: $input) {
                id
            }
        }`;
        
        return await Api.postData('/g', { query: query, variables: {
            input: {
                id: card.id,
                name: card.name,
                skillId: card.skill?.id,
                fields: fields.map(f => {
                    return {
                        name: f.name,
                        value: f.values,
                    };
                }),
            }
        }});
    }
   
    async remove(cardId) {
        let query = `mutation ($id: String!) {
            removeCard(id: $id)
        }`;
        
        return await Api.postData('/g', { query: query, variables: {
            id: cardId
        }});
    }
   
    async saveUserField(cardId, name, values) {
        let query = `mutation ($id: String!, $name: String!, $values: [String!]!) {
            saveUserField(id: $id, name: $name, values: $values)
        }`;
        
        return await Api.postData('/g', { query: query, variables: {
            id: cardId,
            name: name,
            values: values,
        }});
    }    
}